export enum BendingForceCalculationType {
  PRESSING_FORCE = 'PRESSING_FORCE',
  SHEET_THICKNESS = 'SHEET_THICKNESS',
  BENDING_LENGTH = 'BENDING_LENGTH',
}
